<template>
  <div>
    <!-- 상단 제목 -->
    <div class="topbanner">
      <h2>바로 콜 접수하기</h2>
    </div>
    <!--// 상단 제목 -->
    <!-- 메인 컨텐츠 영역 -->
    <article class="main_contents" ref="mainContents">
      <!--      시각장애일 경우 표시-->
      <div v-if="trType === '시각장애' "
           class="accept_wrap">
        <div class="form-group">
          <span>&middot; 이름</span>
          <div class="accept_area">
            <p>{{ user_name }}</p>
          </div>
          <span>&middot; 연락처</span>
          <div class="accept_area">
            <p>{{ user_tel }}</p>
          </div>
        </div>
        <div class="form-group">
          <label for="accept_start">&middot; 출발지</label>
          <div class="accept_area">
            <button class="btn_common" aria-label="출발지 주소 입력"
                    @click="addressPopupShow('s_addr')">출발지 주소 입력
            </button>
            <input type="text" class="form-control" id="accept_start" ref="s_addr"
                   v-model.trim="call.s_show_user" readonly @focus="addressPopupShow('s_addr')"
                   placeholder="출발지 주소 입력"/>
          </div>
        </div>
        <div class="form-group">
          <label for="e_addr">&middot; 도착지</label>
          <div class="accept_area">
            <button class="btn_common" aria-label="도착지 주소 입력"
                    @click="addressPopupShow('e_addr')">도착지 주소 입력
            </button>
            <input type="text" class="form-control" id="e_addr" ref="e_addr"
                   v-model.trim="call.e_show_user" readonly @focus="addressPopupShow('e_addr')"
                   placeholder="도착지 주소 입력"/>
          </div>
        </div>
        <div class="form-group" style="display:none;">
          <span>&middot; 접수유형</span>
          <div class="accept_area">
            <div class="btn_group">
              <button class="btn_common btn_short" :class="move_type==1?'btn_select':''"
                      @click="setMoveType(1)">편도
              </button>
              <button class="btn_common btn_short" :class="move_type==5?'btn_select':''"
                      @click="setMoveType(5)">왕복
              </button>
              <!--button class="btn_common btn_via btn_via_disable">경유</button-->
              <!-- 편도선택 전 비활성상태 -->
              <!--button class="btn_common btn_via">경유</button--> <!-- 편도선택 후 활성상태 -->
              <button class="btn_common btn_via" :class="via_type?'btn_via_select':''"
                      @click="setViaTypeToggle(5)">경유
              </button> <!-- 선택상태 -->
            </div>
          </div>
        </div>
        <div class="form-group">
          <label for="via_addr">&middot; 경유지</label>
          <div class="accept_area">
            <button class="btn_common" aria-label="경유지 주소 입력"
                    @click="addressPopupShow('via_addr')">경유지 추가
            </button>
            <input type="text" class="form-control" id="via_addr" ref="via_addr"
                   v-model.trim="call.via_addr" readonly @focus="addressPopupShow('via_addr')"
                   placeholder="경유지 주소 입력, 없으면 비워두세요."/>
          </div>
        </div>
        <div class="form-group" style="display:none;">
          <label for="accept_via">&middot; 경유지</label>
          <div class="accept_area">
            <input type="text" class="form-control" id="accept_via" ref="via_addr"
                   v-model.trim="call.via_addr" :disabled="!via_type"/>
          </div>
        </div>
        <div class="form-group" style="display:none;">
          <label for="accept_time">&middot; 대기시간</label>
          <div class="accept_area standby_area">
            <span></span>
            <input type="number" class="form-control" id="accept_time" v-model.trim="call.wait_time"
                   min="0" max="120"/> 분
            <small>※ 대기시간은 최대 60분까지 설정 가능합니다.</small>
          </div>
        </div>
      </div><!--시각장애 끝-->

      <!--      신장장애일 경우 표시 -->
      <div v-if="trType === '신장장애' "
           class="accept_wrap">
        <div class="form-group">
          <span>&middot; 이름/연락처</span>
          <div class="accept_area">
            <p>{{ user_name }} / {{ user_tel }}</p>
          </div>

        </div>

        <div style="color:#565656; margin-left:15px; ">
          <span>&middot; 최근 출/도착지</span>
        </div>
        <div class="form-group" style="display: flex;">
          <div style="width: 100% !important;">
            <ul v-if="succeedCallList.length > 0" class="destination-list">
              <li
                  v-for="(item, index) in succeedCallList"
                  :key="index"
                  @click="selectDestination(index, item)"
                  :class="['destination-item', { 'selected': selectedIndex === index }]"
              >
                {{ index + 1 }}.
                {{ item.nmFrGugun + " " + item.nmFr }} <br>
                → {{ item.nmToGugun + " " + item.nmTo }}
              </li>
            </ul>
            <div v-else class="no-destination">
              <p>최근 성공한 목적지가 없습니다. 유선으로 접수해주세요.</p>
              <p>신청접수 : 1600-4477</p>
              <p>신청접수 : 02-2092-0000</p>
            </div>
          </div>
        </div>

        <!--        <div class="form-group">
                  <label for="accept_start">&middot; 출발지</label>
                  <div class="accept_area">
                    <input type="text" class="form-control" id="accept_start" ref="s_addr"
                           v-model.trim="call.s_addr" readonly
                           placeholder="목록에서 선택해주세요"/>
                  </div>
                </div>
                <div class="form-group">
                  <label for="accept_arrival">&middot; 도착지</label>
                  <div class="accept_area">
                    <input type="text" class="form-control" id="accept_arrival" ref="e_addr"
                           v-model.trim="call.e_addr" readonly
                           placeholder="목록에서 선택해주세요"/>
                  </div>
                </div>-->
      </div> <!--신장장애 끝 -->

      <div class="btn_bottom">
        <!--        <button class="btn_common btn_twin" @click="callRequest">접수하기</button>-->
        <!-- 상태 메시지 영역 -->
        <div class="visually-hidden" ref="statusMessage" aria-live="assertive">{{
            statusMessage
          }}
        </div>
        <button
            class="btn_common btn_twin"
            @click="callRequest"
            aria-label="접수하기 버튼"
            id="callRequestButton">
          접수하기
        </button>
        <button class="btn_common btn_twin" @click="callMain">뒤로가기</button>
      </div>
    </article>
    <!--// 메인 컨텐츠 영역 -->
    <Address ref="addressLayer" @setAddressInfo="setAddressInfo"
             @closePopup="addressPopupClose"></Address>
  </div>
</template>

<script>
import Address from '../order/Address';
import axios from "axios";
import process from "shelljs";
import callPreCheck from "../../mixins/callPreCheck";

export default {
  components: {
    Address
  },
  data() {
    return {
      callInfo: null,

      statusMessage: "",
      user_name: "",
      user_tel: "",
      call: {
        call_type: "",
        s_addr: "",
        s_sido: "",
        s_gugun: "",
        s_dong: "",
        s_detail: "",
        s_x: "",
        s_y: "",
        s_show_user: "",

        e_addr: "",
        e_sido: "",
        e_gugun: "",
        e_dong: "",
        e_detail: "",
        e_x: "",
        e_y: "",
        e_show_user: "",

        via_addr: "",
        wait_time: ""
      },
      via_type: false,
      move_type: 1,

      trType: null, // 장애종류
      succeedCallList: [], // 신장장애일 경우 성공한 콜 목록을 저장

      selectedIndex: null,
    }
  },
  mixins: [callPreCheck],
  async mounted() {
    if (this.$store.state.session == null) {
      this.$router.push({path: "/m/login", query: {return_url: "/m/order/call"}});
      return;
    }

    let passed = false;
    await this.callPreCheckThen(() => { passed = true; });
    if (!passed) { this.$router.replace('/m/order/main'); return; }

    await this.progress();

    if (this.callInfo && this.callInfo.ds_status !== 10) {
      await this.$router.replace('/m/order/progress');
      return;
    }

    this.user_name = decodeURIComponent(this.$store.state.session.user_name);
    this.user_tel = this.$store.state.session.user_tel;
    this.getCustomerInfo();
  },
  methods: {
    async progress() {

      await this.$http.get('/api/order/progress.do').then(async (response) => {
        if (response.data.retval == this.CONSTANT.SUCCESS && response.data.callInfo) {
          if (response.data.callInfo.ds_status === 8) {
            this.callInfo = null;
            return;
          }

          if (response.data.callInfo.acs_drvid) {
            this.drvId = response.data.acs_drvid;
          }
          const threeDaysAgo = new Date();
          threeDaysAgo.setDate(threeDaysAgo.getDate() - 3);

          const receiveDateStr = response.data.callInfo.receive_date;
          const year = parseInt(receiveDateStr.slice(0, 4));
          const month = parseInt(receiveDateStr.slice(4, 6)) - 1;
          const day = parseInt(receiveDateStr.slice(6, 8));
          const receiveDate = new Date(year, month, day);

          if (receiveDate >= threeDaysAgo) {
            this.callInfo = response.data.callInfo;
          }

          console.log(this.mapInitialized);
          console.log(this.callInfo.acs_drvid);
          console.log(this.callInfo.ds_status);

        }
      });

    },
    addressPopupShow(addr_type) {
      if (document.activeElement !== this.$refs[addr_type]) {
        this.lastFocusedElement = this.$refs[addr_type]; // 현재 포커스된 요소 저장

        // Call.vue 화면 전체에 aria-hidden 적용
        const mainContents = this.$refs.mainContents; // Call.vue의 main contents를 참조
        const headerContents = document.querySelector("#header_wrap");
        const footerContents = document.querySelector(".footer_wrap");
        const topbanner = document.querySelector(".topbanner");

        if (mainContents) {
          mainContents.setAttribute('aria-hidden', 'true'); // 스크린 리더 접근 차단
          // mainContents.setAttribute('tabindex', '-1');

          const inputs = mainContents.querySelectorAll("input, button, select, textarea");
          inputs.forEach((el) => {
            el.setAttribute("disabled", "true");
            // el.setAttribute("tabindex", "-1");
          });
        }
        if (headerContents) {
          headerContents.setAttribute('aria-hidden', 'true'); // 스크린 리더 접근 차단
          // headerContents.setAttribute('tabindex', '-1');

          const inputs = headerContents.querySelectorAll(
              "input, button, select, textarea, a, li, ul");
          inputs.forEach((el) => {
            el.setAttribute("disabled", "true");
            // el.setAttribute("tabindex", "-1");
          });
        }
        if (footerContents) {
          footerContents.setAttribute('aria-hidden', 'true'); // 스크린 리더 접근 차단
          // footerContents.setAttribute('tabindex', '-1');

          const inputs = footerContents.querySelectorAll(
              "input, button, select, textarea, a, img, p");
          inputs.forEach((el) => {
            el.setAttribute("disabled", "true");
            // el.setAttribute("tabindex", "-1");
          });
        }
        if (topbanner) {
          topbanner.setAttribute('aria-hidden', 'true'); // 스크린 리더 접근 차단
          // topbanner.setAttribute('tabindex', '-1');

          const inputs = topbanner.querySelectorAll("h2");
          inputs.forEach((el) => {
            el.setAttribute("disabled", "true");
            // el.setAttribute("tabindex", "-1");
          });
        }

        this.$refs.addressLayer.addressPopupShow(addr_type); // 팝업 레이어 표시
      }
    },
    setAddressInfo(addr_type, address) {
      console.log(addr_type, address);

      const show_user_address = address.detail_add !== undefined && address.detail_add !== ""
          ? `${address.addr} ${address.detail_add}` : address.addr;

      if (addr_type == 's_addr') {
        this.call.s_addr = address.addr;
        this.call.s_gugun = address.gugun;
        this.call.s_sido = address.sido;
        this.call.s_dong = address.dong;
        this.call.s_detail = address.detail;
        this.call.s_x = address.x;
        this.call.s_y = address.y;

        this.call.s_show_user = show_user_address;
      } else if (addr_type == 'e_addr') {
        this.call.e_addr = address.addr;
        this.call.e_gugun = address.gugun;
        this.call.e_sido = address.sido;
        this.call.e_dong = address.dong;
        this.call.e_detail = address.detail;
        this.call.e_x = address.x;
        this.call.e_y = address.y;

        this.call.e_show_user = show_user_address;
      } else {
        this.call.via_addr = show_user_address;
      }

      this.addressPopupClose();
    },
    addressPopupClose() {
      // Call.vue 화면에 aria-hidden 해제
      const mainContents = this.$refs.mainContents;
      const headerContents = document.querySelector("#header_wrap");
      const footerContents = document.querySelector(".footer_wrap");
      const topbanner = document.querySelector(".topbanner");

      if (mainContents) {
        mainContents.removeAttribute('aria-hidden'); // 접근성 복구
        mainContents.removeAttribute('tabindex'); // 접근성 복구
        const inputs = mainContents.querySelectorAll("input, button, select, textarea");
        inputs.forEach((el) => {
          el.removeAttribute("disabled");
          el.removeAttribute("tabindex");
        });
      }

      if (headerContents) {
        headerContents.removeAttribute('aria-hidden'); // 접근성 복구
        headerContents.removeAttribute('tabindex');

        const inputs = headerContents.querySelectorAll(
            "input, button, select, textarea, a, li, ul");
        inputs.forEach((el) => {
          el.removeAttribute("disabled");
          el.removeAttribute("tabindex");
        });
      }
      if (footerContents) {
        footerContents.removeAttribute('aria-hidden'); // 접근성 복구
        footerContents.removeAttribute('tabindex');

        const inputs = footerContents.querySelectorAll(
            "input, button, select, textarea, a, img, p");
        inputs.forEach((el) => {
          el.removeAttribute("disabled");
          el.removeAttribute("tabindex");
        });
      }
      if (topbanner) {
        topbanner.removeAttribute('aria-hidden'); // 접근성 복구
        topbanner.removeAttribute('tabindex');

        const inputs = topbanner.querySelectorAll("h2");
        inputs.forEach((el) => {
          el.removeAttribute("disabled");
          el.removeAttribute("tabindex");
        });
      }

      // 저장된 포커스로 복구
      this.$nextTick(() => {
        if (this.lastFocusedElement && typeof this.lastFocusedElement.focus === 'function') {
          this.lastFocusedElement.focus();
        }
      });
    },
    selectDestination(index, item) {

      const s_addr = [item.nmFrSido, item.nmFrGugun, item.nmFr].join(" ");
      const e_addr = [item.nmToSido, item.nmToGugun, item.nmTo].join(" ");

      if (!confirm(`선택하신 출발지, 도착지가 아래와 같습니까? \n  출발지: ${s_addr} \n  도착지: ${e_addr}`)) {
        return;
      }

      this.selectedIndex = index;

      // 출발지 정보
      this.call.s_addr = s_addr
      this.call.s_gugun = item.nmFrGugun;
      this.call.s_sido = item.nmFrSido;
      this.call.s_dong = item.nmFrDong;
      this.call.s_detail = item.nmFr;
      this.call.s_x = item.noFrX;
      this.call.s_y = item.noFrY;

      // 도착지 정보
      this.call.e_addr = e_addr;
      this.call.e_gugun = item.nmToGugun;
      this.call.e_sido = item.nmToSido;
      this.call.e_dong = item.nmToDong;
      this.call.e_detail = item.nmTo;
      this.call.e_x = item.noToX;
      this.call.e_y = item.noToY;
    },
    setMoveType(move_type) {
      this.move_type = move_type;
    },
    setViaTypeToggle() {
      this.via_type = !this.via_type;
    },
    callRequest() {
      var wait_type = "";
      var out_type = "";

      if (this.call.s_addr == "") {
        alert("출발지를 입력해주세요.");
        this.$refs.s_addr.focus();
        return;
      }

      if (this.call.e_addr == "") {
        alert("도착지를 입력해주세요.");
        this.$refs.e_addr.focus();
        return;
      }

      if (this.via_type && this.call.via_addr == "") {
        alert("경유지를 입력해주세요.");
        this.$refs.via_addr.focus();
        return;
      }

      // 시외 체크
      if (this.call.s_sido.indexOf('서울') < 0 || this.call.e_sido.indexOf('서울') < 0) {
        out_type = "3";
      }

      // 대기시간 체크
      if (this.call.wait_time != "") {
        if (this.call.wait_time > 60) {
          alert("대기시간은 60분까지만 가능합니다.");
          this.$refs.wait_time.focus();
          return;
        } else if (this.call.wait_time > 0 && this.call.wait_time <= 60) {
          wait_type = "4";
        }
      }

      // 편도
      if (this.move_type == "1") {
        // 경유 있음
        if (this.via_type) {
          this.call.call_type = "2" + out_type + wait_type;
          // 경유 없음
        } else {
          this.call.call_type = this.move_type + out_type + wait_type;
        }
        // 왕복
      } else {
        this.call.call_type = (this.via_type ? "2" : "") + out_type + wait_type + this.move_type;
      }

      // if (!confirm(
      //     `다음의 출발지, 도착지로 접수하시겠습니까? \n  출발지: ${this.call.s_show_user}  \n  도착지: ${this.call.e_show_user}`)) {
      //   return;
      // }

      this.$http.get("/api/order/callAction.do", {
        params: this.call
      }).then((response) => {
        if (response.data.retval == this.CONSTANT.SUCCESS) {
          //alert("접수가 완료되었습니다.");

          // 성공 메시지 업데이트
          this.statusMessage = "접수가 완료되었습니다.";
          // 메시지가 읽히도록 약간의 대기 시간 후 페이지 이동
          setTimeout(() => {
            this.$router.push("/m/order/progress");
          }, 2000); // 1초 대기
        } else if (response.data.preCheckCode) {
          alert(response.data.error_msg);
        } else {
          if (response.data.retval == this.CONSTANT.LOGIN_ERROR) {
            this.$store.commit("setSession", null);
            this.$router.push({path: "/m/login", query: {return_url: "/m/order/call"}});
          } else if (response.data.retval == this.CONSTANT.CALL_STOP_ERROR) {
            alert("시스템 점검 중으로 접수가 되지 않았습니다.\n전화로 접수해 주시기 바랍니다.");
          } else {
            if (response.data.error_msg.trim() == "There is a call registered within 1 hour") {
              alert("이미 접수된 콜 내역이 있습니다.\n다시 접수하시려면 취소 후 진행해주세요.");
            } else {
              alert("콜 접수 요청을 실패 하였습니다. [error_code:" + response.data.retval + "]");
            }
          }
        }
      });

      // 포커스 이동
      this.$nextTick(() => {
        const focusTarget = document.querySelector("#callRequestButton");
        if (focusTarget) {
          focusTarget.focus();
        }
      });
    },
    callMain() {
      this.$router.push("/m/order/main");
    },

    /* 고객의 장애 타입 조회 */
    async getCustomerInfo() {
      try {
        const url = "/api/order/customer.do";

        const response = await axios.post(
            url,
            {
              pkCusSeq: this.$store.state.session.user_id,
              count: 1
            },
            {
              headers: {
                "Content-Type": "application/json"
              }
            }
        );
        if (response.data.code === "0000") {
          this.trType = response.data.data[0].trType;

          if (this.trType === '신장장애') {
            this.succeedCallList = await this.getSucceedCallList(this.$store.state.session.user_id);
          }
        }
      } catch (err) {
        console.log(err);
      }
    },

    /* 고객의 장애 종류가 신장장애일 경우 최근 성공 목록 10개를 출력한다.
    * 해당 목록에서 선택해서 콜 접수 가능 */
    async getSucceedCallList(noCustSeq) {
      try {
        const url = "/api/order/call.do";
        // const url = process.env.VUE_APP_API_URL + "/order/call.do";

        const response = await axios.post(
            url,
            {
              // noCusSeq: noCustSeq,
              noCusSeq: noCustSeq,
              count: 20
            },
            {
              headers: {
                "Content-Type": "application/json"
              }
            }
        );
        if (response.data.code === "0000") {
          const seen = new Set();
          return response.data.data.filter(item => {
            const key = [item.nmFrSido, item.nmFrGugun, item.nmFr, item.nmToSido, item.nmToGugun,
              item.nmTo].join("-");

            if (item.dsStatus === 8 && !seen.has(key)) {
              seen.add(key);
              return true;
            }
            return false;
          });
        }
      } catch (err) {
        console.log(err);
      }
    }
  }
}
</script>
<style scoped>
.destination-list {
  list-style: none; /* 기본 리스트 스타일 제거 */
  padding: 0;
  margin: 0;
}

.destination-item {
  display: block;
  margin: 10px 0; /* 리스트 간격 */
  padding: 10px 15px; /* 버튼 내부 패딩 */
  border: 1px solid #ddd; /* 테두리 */
  border-radius: 5px; /* 모서리 둥글게 */
  background-color: #f5f5f5; /* 배경색 */
  font-size: 16px; /* 글자 크기 */
  color: #333; /* 글자 색상 */
  cursor: pointer; /* 마우스 모양 변경 */
  text-align: left; /* 텍스트 정렬 */
  transition: background-color 0.3s, transform 0.2s; /* 전환 효과 */
}

.destination-item.selected {
  font-weight: bold;
  border: 2px solid #007BFF; /* 더 강한 테두리 */
  background-color: #e8f3ff; /* 선택된 상태의 배경색 */
  color: #0056b3; /* 선택된 상태 텍스트 색상 */
}

</style>


// WEBPACK FOOTER //
// src/pages/order/Call.vue